import { request as update } from './reducers/update';
import { request as settle } from './reducers/settle';
import { request as result, resultBulkSelections } from './reducers/result';
import { request as unsettle } from './reducers/unsettle';
import { request as moveSelections } from './reducers/move-selections';

// eslint-disable-next-line import/no-default-export
export default {
    SELECTIONS_UPDATE_REQUEST: update,
    SELECTIONS_RESULT_REQUEST: result,
    SELECTIONS_RESULT_BULK_REQUEST: resultBulkSelections,
    SELECTIONS_SETTLE_REQUEST: settle,
    SELECTIONS_UNSETTLE_REQUEST: unsettle,
    MARKETS_MOVE_SELECTION_REQUEST: moveSelections,
};
